"use client";
import { MemberEligibility } from "@/server/models/member/member-eligibility";
import React, { createContext } from "react";

type CurrentMember = {
  memberName: string;
  sex: "male" | "female" | null;
  dateOfBirth: string | null;
  relationshipToPrimary: string | null;
  eligibility?: MemberEligibility;
  insuranceNumberId?: string;
  officeName: string;
};

const CurrentMemberContext = createContext<CurrentMember>({
  memberName: "",
  sex: null,
  dateOfBirth: null,
  relationshipToPrimary: null,
  eligibility: undefined,
  insuranceNumberId: undefined,
  officeName: "",
});

export const CurrentMemberContextProvider = ({
  children,
  member,
}: {
  children: React.ReactNode;
  member: CurrentMember;
}) => (
  <CurrentMemberContext.Provider value={member}>
    {children}
  </CurrentMemberContext.Provider>
);

export const useCurrentMember = () => React.useContext(CurrentMemberContext);

/**
 * 通常の被保険者（任意継続・被扶養者を除く）かどうかを判定する
 */
export const isRegularInsured = (
  member: Pick<CurrentMember, "relationshipToPrimary" | "eligibility">,
): boolean =>
  member.relationshipToPrimary === null &&
  member.eligibility !== "optional_and_continued";
